// Loosely center the Europe
export const DEFAULT_MAP_CONFIG = {
    center: {
        lat: 48,
        lng: 13,
    },
    zoom: 4,
};
